/**
 * Created by neo on 20.03.2024
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { Media, createMedia } from '../../Media/Media';
import { LocalizedEntity, createLocalizedEntity } from '../../LocalizedEntity';

export type RouteChallengeWalkthroughEntry = LocalizedEntity & {
  image?: Media;
};

export function createRouteChallengeWalkthroughEntry(json?: Partial<RouteChallengeWalkthroughEntry>): RouteChallengeWalkthroughEntry {
  const base = createLocalizedEntity(json as any);
  return makeAutoObservable({
    ...base,
    image: json?.image ? createMedia(json.image as any) : undefined,

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        image: this.image,
      };
    },
  });
}
